import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';

import { PRICE_FILTER_LIMITS } from '../components/ItemsFilters/PriceFilter';

export const ITEMS_FILTERS_FOR_COUNT = [
  ITEM_FILTERS.SIZE,
  ITEM_FILTERS.SELLER_NAME,
  ITEM_FILTERS.MIN_PRICE,
  ITEM_FILTERS.MAX_PRICE,
];

export const getFilterCount = (filters: any) => {
  let count = 0;

  for (const filter in filters) {
    if (!ITEMS_FILTERS_FOR_COUNT.includes(filter)) {
      continue;
    }

    const value = filters[filter];
    if (filter === ITEM_FILTERS.SIZE && value !== undefined && value !== '') {
      count += 1;
    }

    if (
      filter === ITEM_FILTERS.CATEGORY &&
      value !== undefined &&
      value !== ''
    ) {
      count += 1;
    }

    if (
      (filter === ITEM_FILTERS.MIN_PRICE &&
        value !== undefined &&
        Number(value) !== PRICE_FILTER_LIMITS.MIN) ||
      (filter === ITEM_FILTERS.MAX_PRICE &&
        value !== undefined &&
        Number(value) !== PRICE_FILTER_LIMITS.MAX)
    ) {
      count += 1;
    }

    if (
      filter === ITEM_FILTERS.SELLER_NAME &&
      value !== undefined &&
      value !== null &&
      value !== ''
    ) {
      count += 1;
    }
  }

  return count;
};
